import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { Profile } from "@customTypes/profile";

import { profileQKeys } from "./queryKeys";


interface QueryProps {
  userId: string;
  isEnabled?: boolean;
}

const select = (res: any): Profile | null => {
  if (res.data) {
    const profile = res.data;
    return {
      id: profile._id,
      slug: profile.slug,
      bookingUrl: profile.booking_url,
      profileImage: profile.profile_image,
      profileType: profile.profile_type,
      specialization: profile.specialization,
      primarySpecializationId: profile.primary_specialization_id,
      primarySpecialization: profile.primary_specialization,
      briefDescription: profile.brief_description,
      location: profile.location,
      yearsOfExperience: profile.years_of_experience,
      licenseNumber: profile.license_number,
      licensedCountries: profile.licensed_countries || [],
      specialties: profile.specialties || [],
      services: profile.services || [],
      education: profile.education || [],
      languages: profile.languages || [],
      officeHours: profile.office_hours,
      socialMedia: profile.social_media || {},
      awardsAndPublications: profile.awards_and_publications || [],
      professionalMemberships: profile.professional_memberships || [],
      consultationModes: profile.consultation_modes || [],
      visibility: profile.visibility,
      partnerId: profile.partner_id,
      userId: profile.user_id,
      userInfo: profile.user_info ? {
        id: profile.user_info._id,
        fullName: profile.user_info.full_name,
        username: profile.user_info.username,
        email: profile.user_info.email,
        phoneNumber: profile.user_info.phone_number,
        isActive: profile.user_info.is_active,
        partnerIds: profile.user_info.partner_ids || [],
        medicalLicenseUrl: profile.user_info.medical_license_url,
        proofOfQualificationUrl: profile.user_info.proof_of_qualification_url,
      } : profile.user_info,
      partnerInfo: profile.partner_info ? {
        id: profile.partner_info._id,
        name: profile.partner_info.name,
        enterpriseId: profile.partner_info.enterprise_id,
        createdAt: profile.partner_info.created_at,
        updatedAt: profile.partner_info.updated_at,
      } : profile.partner_info,
      createdAt: profile.created_at,
      updatedAt: profile.updated_at,
      archived: profile.archived || false,
    };
  }
  return null;
};

export const useGetProfileByUserId = ({ userId, isEnabled = true }: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: profileQKeys.byUserId(userId),
    queryFn: () => {
      return api.get(`profile/user/${userId}`);
    },
    select,
    enabled: isEnabled && !!userId,
    staleTime: 1000 * 60 * 5, // 5 minutes

    onError: (res: any) => {
      console.error("[From Get Profile By User ID]", res);
      handleErrors(res, "query");
    },
  });
};
